import React from 'react';
import { useFileContext } from '../../../Contexts/FileContext';
import { useSearchParams } from 'react-router-dom';
import pdfIcon from "../../../assets/images/pdf.png";
import { WebApiURL } from '../../../Constants/Constants';
import { encryptFileIdValue } from "../../../utils/encryption";

import CryptoJS from "crypto-js";
function LegislationSearchResults({ searchTerm: propSearchTerm }) {
  const { allDocuments } = useFileContext();
  const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
  const [searchParams] = useSearchParams();
  const secretKey = "MySAMSASecretKey2025"; // same as backend

  const encryptFileId = (fileId) => {
    const ciphertext = CryptoJS.AES.encrypt(fileId.toString(), secretKey).toString();
    return encodeURIComponent(ciphertext);
  };

  const searchTerm = propSearchTerm ?? searchParams.get("searchterm") ?? "";
  const safeTerm = searchTerm?.trim() || "";
  const filteredDocs =
    safeTerm.length >= 3
      ? allDocuments.filter(doc => {
        const lowerSearch = safeTerm.toLowerCase();
        const fileNameMatch = doc.fileName?.toLowerCase().includes(lowerSearch);
        const pageMatch = (doc.page ?? "").toString().toLowerCase() === "legislation";
        return fileNameMatch && pageMatch;
      })
      : [];

  const groupedDocs = filteredDocs.reduce((acc, doc) => {
    const folder = doc.folderName || 'Uncategorized';
    if (!acc[folder]) acc[folder] = [];
    acc[folder].push(doc);
    return acc;
  }, {});

  return (
    <div className="col-12">
      <div className="service-title font-700 mb-3 text-uppercase">
        Search Results for
        <span className="text-orange-ef3e33 font-400">
          {searchTerm && ` ${searchTerm}`}
        </span>
      </div>
      {safeTerm.length >= 3 && filteredDocs.length === 0 ? (
        <div>No search results found. Please try again with a proper search.</div>
      ) : (
        <ul className="strip-ul mt-3">
          {Object.entries(groupedDocs).map(([folderName, docs], index) => (
            <li className="bg-transparent p-0" key={index}>
              <div className="row g-4">
                <div className="col-auto">
                  <img style={{ width: "40px" }} src={pdfIcon} alt="PDF icon" />
                </div>
                <div className="col">
                  <div className="row g-4">
                    <div className="col-md">
                      <div className="font-18 font-600">File Name</div>
                      <div className="font-16 font-400">
                        <p className="text-orange-ef3e33 text-uppercase">{folderName}</p>
                        <ul className="list">
                          {docs.map((item, i) => (
                            <li key={i}>
                              {/* <a
                                href={`${WebApiURL}File/view/${encodeURIComponent(item.fileId)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item.fileName}
                              </a> */}
                              <a
                                href={`${WebApiURL}File/view/${encryptFileIdValue(item.fileId)}`}

                                //href={`${WebApiURL}File/view/${encodeBase64(item.fileId.toString())}`}
                                // target="_blank"
                                rel="noopener noreferrer"
                              >{item.fileName}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    {/* <div className="col-md-auto">
                      <div className="font-18 font-600">Modified</div>
                      <div className="font-16 font-400">
                        {docs[0]?.modifiedDate
                          ? new Date(docs[0].modifiedDate).toLocaleString()
                          : '—'}
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LegislationSearchResults;
